import { api } from "../../api"

export async function loadBanner(): Promise<Banner[]> {
    let banner = await api<any>("banner", {})
    return banner.data.map(e => e.banner)
}
